import classNames from 'classnames';
import React, {
    ForwardedRef,
    forwardRef,
    ForwardRefExoticComponent,
    MouseEventHandler,
    PropsWithoutRef,
    ReactElement,
    RefAttributes,
} from 'react';

import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import styles from './DotPagination.module.css';

export type IDotBaseProps = IQATestableProps & IStyleableProps & {
    'aria-label': string;
    'aria-current'?: 'page';
    index: number;
    onClick?: MouseEventHandler;
    onMouseDown?: MouseEventHandler;
};

export const DotBase: ForwardRefExoticComponent<PropsWithoutRef<IDotBaseProps> & RefAttributes<HTMLButtonElement>> = forwardRef<HTMLButtonElement, IDotBaseProps>(
    (props: IDotBaseProps, ref: ForwardedRef<HTMLButtonElement>): ReactElement => {
        const {
            index,
            onClick,
            onMouseDown,
            'aria-label': ariaLabel,
            'aria-current': ariaCurrent,
            'data-testid': dataTestId,
            className = '',
        }: IDotBaseProps = props;

        const baseClassNames: string = classNames({
            'rounded-full focus-visible:outline focus-visible:outline-1 focus-visible:outline-blue-500': true,
            [styles.dot]: true,
        });

        return (
            <button
                ref={ref}
                data-index={index + ''}
                aria-current={ariaCurrent}
                aria-label={ariaLabel}
                type="button"
                onClick={onClick}
                onMouseDown={onMouseDown}
                data-testid={dataTestId}
                className={baseClassNames + ' ' + className}
            />
        );
    },
);
